{
  "labels": {
    "tuje": "Aeromobile straniero?",
    "reg": "Registrazione",
    "masa_plovila": "Teža plovila",
    "klub": "Seleziona club:",
    "stUr": "Numero di ore:",
    "stLetov": "Numero di voli:",
    "datumN": "Data di acquisto:",
    "datumR": "Data di registrazione:",
    "vrsta": "Seleziona tipo:",
    "vlecno": "Aereo da traino:",
    "vlecnoD": "Sì",
    "vlecnoN": "No",
    "opomba": "Nota",
    "obracunStevec": "Registrazione del tempo di volo:",
    "razpolozljivost": "Mostra nella disponibilità:",
    "camo_pregled": "Mostra nella CAMO:",
    "camo_flight": "Visualizzazione del tempo di volo in CAMO:"
  },
  "buttons": {
    "vnos": "Inserisci record",
    "brisiIzbiro": "Cancella selezione"
  }
}